import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Train } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-screen flex items-center justify-center px-6 pt-safe-navbar pb-16">
      <div className="iq-card w-full max-w-lg p-10 text-center animate-fade-up">
        <div className="inline-flex items-center gap-2 justify-center mb-6">
          <span className="inline-flex h-9 w-9 items-center justify-center bg-gold text-ink rounded-sm">
            <Train className="h-5 w-5" strokeWidth={2.5} />
          </span>
          <span className="font-display text-xl tracking-[0.18em] text-cream">INTERQUEST</span>
        </div>
        <div data-testid="notfound-code" className="font-display text-gold text-[8rem] md:text-[10rem] leading-none tracking-tight">
          404
        </div>
        <h1 className="font-display text-cream text-4xl md:text-5xl tracking-wider mt-2 mb-3">
          Wrong platform.
        </h1>
        <p className="font-serif italic text-cream-dim text-lg leading-relaxed mb-8">
          This stop isn't on the timetable.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="iq-btn-primary inline-flex"
        >
          Back to the main concourse <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
